module.exports = __webpack_public_path__ + "static/media/cheeseburger.9c507298.svg";